import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { params } from './plugin'


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutSystem',
  setup(__props) {

const layout = ref()
const route = useRoute()

watch( () => route.meta, async meta => {
    layout.value = meta.layout || params.defaultLayout
}) 


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value), null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})